import { useEffect } from 'react';
import { useBreadcrumbs, BreadcrumbItem } from '../contexts/BreadcrumbContext';

export const useBreadcrumbSetter = (breadcrumbs: BreadcrumbItem[]) => {
  const { setBreadcrumbs, clearBreadcrumbs } = useBreadcrumbs();

  useEffect(() => {
    setBreadcrumbs(breadcrumbs);
    
    return () => {
      clearBreadcrumbs();
    };
  }, [breadcrumbs, setBreadcrumbs, clearBreadcrumbs]);
};